<template lang="pug">
section.popup
  .popup__overlay
  .popup__view
    .popup__body.popup__body_login
      transition(name="error__message")
        span.error__message(v-if="error") {{ errorMessage }}
      .popup__close(@click="close")
        icon(name="close")
      .popup__header {{$t('msgs.activateCode')}}
      .popup__main.code-wrapper
        .input.input__phone
          input(v-model="code",
                type="text",
                :placeholder="`${$t('promo.putNumber')}`")
      .popup__footer.text-center
        .row
          button.button.button_primary(@click="activate()") {{$t('promo.activate')}}
</template>

<script>
import icon from '@/components/Icons.vue';
import API from '@/api/api';
export default {
  components: {
    icon,
  },
  data: () => ({
    code: '',
    error: false,
    errorMessage: '',
    errorId: null,
  }),
  methods: {
    async activate() {
      if (!this.code || !this.code.length) {
        this.showError(this.$t('promo.noEmpty'));
        return;
      }
      const data = await API.activatePromocode({
        code: this.code,
      }, (error) => {
        console.log('ERR promocode', error);
        this.showError(this.$t('promo.incorrectNumber'));
      });
      if (data) {
        window.location.reload();
        this.close();
      }
    },

    close() {
      this.$emit('close');
    },

    showError(message = '') {
      if (!message.length) {
        return;
      }
      this.errorMessage = message;
      if (this.errorId) {
        clearTimeout(this.errorId);
      }
      this.error = true;
      this.errorId = setTimeout(() => {
        this.error = false;
        this.errorMessage = '';
        clearTimeout(this.errorId);
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.code-wrapper{
  min-width: 280px;
  margin: 20px 0;
}
</style>
